export default "__VITE_ASSET__BaXXFFVU__"